import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Link2approve extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //console.log(this.props.match.params[0]);
    //this.props.getuser(this.props.match.params[0]);
    console.log('I  am in componentDidMount ');
    this.props.saveMemberName(this.props.match.params.id);
//    sessionStorage.setItem('tptpg', '/approve');
    this.props.gotopage();
  }

  // componentWillUnmount() {
  //   console.log('I  am in componentWillUnMount ');
  //   //this.props.getuser(this.props.match.params.id);
  //   sessionStorage.setItem('tptpg', '/approve');
  // }

  render() {
    // return <div>{new Date()}</div>;
    return null;
  }
}

Link2approve.propTypes = {
  saveMemberName: PropTypes.func.isRequired,
  gotopage: PropTypes.func.isRequired
};

export default Link2approve;



// WEBPACK FOOTER //
// ./src/components/views/Link2approve/index.js